import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ModalService, PatientService } from '../../services';

@Component({
  selector: 'app-download-file-document',
  templateUrl: './download-file-document.component.html',
  styleUrls: ['./download-file-document.component.scss']
})
export class DownloadFileDocumentComponent {

  @Input() nameOfFile;

  constructor(
    private translate: TranslateService,
    private patientService: PatientService,
    private modalService: ModalService
  ) {}

  get canPreview(): boolean {
    return this.displayableMimeType() !== '';
  }

  downloadFile() {
    this.patientService.getDocumentFromDocumentation(this.nameOfFile).subscribe(
      data => {
        const objectUrl = URL.createObjectURL(this.toBlob(data.data));
        const anchor = document.createElement('a');

        anchor.href = objectUrl;
        anchor.download = this.nameOfFile;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        URL.revokeObjectURL(objectUrl);
      },
      () => this.modalService.open(this.translate.instant('BACKEND.COULDNT-GET-DATA'), undefined, undefined, 'EVENTS.SHARED.COMPONENTS.DOWNLOAD-FILE-DOCUMENT.POPUP.BACKEND-COULDNT-GET-DATA'));
  }

  // previewFile() {
  //   // Okno musi powstać w obsłudze kliknięcia — otwarte dopiero po odpowiedzi backendu
  //   // ląduje w blokadzie wyskakujących okien.
  //   const preview = window.open('', '_blank');
  //
  //   if (!preview) {
  //     this.modalService.open(this.translate.instant('DOCUMENTS.PREVIEW-BLOCKED'));
  //     return;
  //   }
  //
  //   // Wyjątek z `toBlob` nie trafia do gałęzi błędu subscribe, a zostawiona pusta karta
  //   // nie powiedziałaby użytkownikowi nic.
  //   const failed = () => {
  //     preview.close();
  //     this.modalService.open(this.translate.instant('BACKEND.COULDNT-GET-DATA'));
  //   };
  //
  //   this.patientService.getDocumentFromDocumentation(this.nameOfFile).subscribe(
  //     data => {
  //       try {
  //         preview.location.href = URL.createObjectURL(this.toBlob(data.data));
  //       } catch {
  //         failed();
  //       }
  //     },
  //     failed);
  // }

  private toBlob(base64: string): Blob {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    return new Blob([bytes.buffer], { type: this.displayableMimeType() });
  }

  private displayableMimeType(): string {
    const extension = (this.nameOfFile || '').split('.').pop().toLowerCase();

    switch (extension) {
      case 'pdf': return 'application/pdf';
      case 'jpg':
      case 'jpeg': return 'image/jpeg';
      case 'png': return 'image/png';
      case 'txt': return 'text/plain';
      case 'mp4': return 'video/mp4';
      default: return '';
    }
  }

}
